import { Component, Input, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Plugins } from "@capacitor/core";
import { ModalController } from "@ionic/angular";
import { Tipo } from "src/app/models/tipo.model";
import { TiposService } from "src/app/services/tipos.service";
const { Toast, Modals } = Plugins;

@Component({
  selector: "app-tipo-modal",
  templateUrl: "./tipo-modal.page.html",
  styleUrls: ["./tipo-modal.page.scss"],
})
export class TipoModalPage implements OnInit {
  @Input() type: string;
  @Input() tipo: Tipo;

  modoEditar: boolean = false;
  formTipo: FormGroup;

  constructor(
    private modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private tipoService: TiposService
  ) {}

  ngOnInit() {
    this.formulario();
  }

  formulario() {
    this.formTipo = this.formBuilder.group({
      nomeTipo: new FormControl("", Validators.required),
    });

    if (this.type === "editar") {
      this.modoEditar = true;
      this.formTipo.get("nomeTipo").setValue(this.tipo.nomeTipo);
    }
  }

  editar(tipo: Tipo) {
    const updatedTipo = new Tipo().deserialize({
      ...this.tipo,
      nomeTipo: tipo.nomeTipo,
    });
    this.tipoService.edit(updatedTipo).subscribe(
      async () => {
        await Toast.show({
          text: `${tipo.nomeTipo} atualizada.`,
          duration: "long",
        });
      },
      async (erro) => {
        await Modals.alert({
          title: "Erro",
          message: `${erro.error.message}`,
        });
      },
      () => {
        this.fecharJanela();
      }
    );

    async (error) => {
      await Modals.alert({
        title: "Erro",
        message: `${error.error.message}`,
      });
    };
  }

  salvar(tipo: Tipo) {
    this.tipoService.create(tipo).subscribe(
      async () => {
        await Toast.show({
          text: `Novo tipo ${tipo.nomeTipo} criado.`,
          duration: "long",
        });
      },
      async (error) => {
        await Modals.alert({
          title: "Erro",
          message: `${error.error.message}`,
        });
      },
      () => {
        this.fecharJanela();
      }
    );
    async (error) => {
      await Modals.alert({
        title: "Erro",
        message: `${error.error.message}`,
      });
    };
  }

  fecharJanela() {
    this.modalCtrl.dismiss({
      dissmissed: true,
    });
  }
}
